const React = require('react')
const { useState, useEffect } = require('react')
const { Button } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { ConnectMetamask } = require('../../connectMetamask')
const { ExpandableRead } = require('./expandable.read')
const { keccak256, toHex } = require('viem')

require('@styles/pages/address/contract.address.css')

const ReadContract = props => {
    const { data } = props
    const { network } = useNetworkConfig()

    const [account, setAccount] = useState(null)
    const [abi, setAbi] = useState([])

    useEffect(() => {
        if (data) {
            try {
                const viewFunctions = data.information.contract.abi
                    .filter(
                        item =>
                            item.type === 'function' &&
                            (item.stateMutability === 'view' || item.stateMutability === 'pure')
                    )
                    .map(func => ({
                        ...func,
                        signature: keccak256(toHex(`${func.name}(${func.inputs.map(i => i.type).join(',')})`)).slice(
                            0,
                            10
                        )
                    }))

                setAbi(viewFunctions)
            } catch (error) {
                console.error('Error parsing ABI:', error)
            }
        }
    }, [data])

    const [expandedSections, setExpandedSections] = useState(() => {
        const initialState = {}
        abi.forEach((_, index) => {
            initialState[index] = false
        })
        return initialState
    })

    const toggleExpand = index => {
        setExpandedSections(prev => ({
            ...prev,
            [index]: !prev[index]
        }))
    }

    const expandAll = () => {
        const allExpanded = abi.every((_, index) => expandedSections[index])
        const expanded = {}
        abi.forEach((_, index) => {
            expanded[index] = !allExpanded
        })
        setExpandedSections(expanded)
    }

    return (
        <div style={{ margin: '32px 0' }}>
            <ConnectMetamask account={account} setAccount={setAccount} />

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    margin: '8px 0 '
                }}
            >
                <div style={{ fontSize: '14px' }}>
                    <i className='fas fa-file-alt' />
                    &nbsp;Read Contract Information
                </div>
                <Button
                    onClick={expandAll}
                    style={{
                        padding: '5px 15px',
                        background: 'transparent',
                        color: 'var(--success-color)',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '12px'
                    }}
                >
                    <span className={`${network.name}-text-color`}>
                        {abi.every((_, index) => expandedSections[index]) ? 'Collapse All' : 'Expand All'}
                    </span>
                </Button>
            </div>

            <div>
                {abi.map((func, index) => (
                    <ExpandableRead
                        key={index}
                        data={data}
                        abi={abi}
                        account={account}
                        index={index}
                        func={func}
                        isExpanded={expandedSections[index]}
                        onToggle={() => toggleExpand(index)}
                    />
                ))}
            </div>
        </div>
    )
}

module.exports = { ReadContract }
